import React, { FC, useEffect, useContext } from 'react';

import { useHistory } from 'react-router-dom';

import { Loader } from '../../components/Loader';
import { ScriptsContext } from '../../context/ScriptsContext';
import { useAuth } from '../../utils/hooks';

interface LogoutPageProps {
  loadingUser: boolean;
}

const LogoutPage: FC<LogoutPageProps> = ({ loadingUser }) => {
  const history = useHistory();
  const { logout, isAuthenticated, isLoading, isInitialized } = useAuth();
  const { isUserComScriptLoaded } = useContext(ScriptsContext);

  useEffect(() => {
    const handleLogout = async () => {
      if (isInitialized && !isLoading && !loadingUser) {
        if (isAuthenticated) {
          if (isUserComScriptLoaded && window?.UE?.resetAuth) {
            await window?.UE?.resetAuth({
              apiKey: process.env.REACT_APP_USERCOM_API_KEY,
            });
          }
          logout();
        } else {
          history.replace('/');
        }
      }
    };

    handleLogout();
  }, [
    isInitialized,
    isLoading,
    isAuthenticated,
    logout,
    history,
    loadingUser,
    isUserComScriptLoaded,
  ]);

  return <Loader />;
};

export default LogoutPage;
